// MapNode is the panel on the screen that contains the map. It is responsible
// for the full panel as well as the map grid and all tiles within.

import { useGameStateContext } from 'app/src/game/GameStateContext';
import MovableItemWrapper from 'app/src/game/map/MovableItemWrapper';
import TileNode from 'app/src/game/map/TileNode';
import * as React from 'react';

export default function MapNode(): React.ReactElement | null {
	const { gameStateStore } = useGameStateContext();

	return (
		<div className="Map">
			<div className="Map-outline">
				<table className="Map-grid">
					<tbody>
						{gameStateStore.tiles.map((rowArr, row) => (
							<tr key={`Map--row-${row}`}>
								{rowArr.map((tile, col) => {
									const star =
										Array.from(gameStateStore.stars).find(
											(s) => s.location.row === row && s.location.col === col,
										) || null;

									return (
										<td key={`Map--row-${row}-col-${col}`} className="Map-cell">
											<TileNode row={row} col={col} tile={tile} star={star} />
										</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
				<div className="Map-MovableItemsContainer">
					{Array.from(gameStateStore.movableItems).map((movableItem) => (
						<MovableItemWrapper
							key={`MovableItemWrapper-${movableItem.id}`}
							movableItem={movableItem}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
